import { Component, OnInit, LOCALE_ID } from '@angular/core';
import { SeoService } from 'src/app/seo.service';
import { BlogPageService } from '../blog-page/blog-page.service';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss'],
  providers: [{ provide: LOCALE_ID, useValue: 'fr' }]
})
export class BlogPageComponent implements OnInit {
  public data: any;
  public data2: any;
  blogGrid: number = 1;
  articles: any[] = [];
  featuredArticle: any;
  allArticles: any[] = [];
  displayedArticles: any[] = [];
  articlesPerPage = 6;
  private validCategories = ['news', 'hebdo', 'data', 'echo'];
  
  // État de chargement
  isLoading = true;
  isContentReady = false;

  constructor(
    private content: BlogPageService,
    private route: ActivatedRoute,
    private seo: SeoService,
  ) {}

  ngOnInit(): void {
    this.seo.updateMeta(
      "AfroTech News - Actualités Tech Africaines",
      "Tendances, chiffres, idées et pépites venues du continent. À lire, à partager, à faire rayonner.",
      "https://res.cloudinary.com/dvapjthfn/image/upload/v1747960441/afro_2_aacf8589e7.png?updated_at=2025-05-23T00:34:01.868Z.png",
      "https://afrotech-hub.com/news",
      "AfroTech News, Actualités Tech Africaines, Tendances, Chiffres, Idées, Pépites, AfroTech Hub"
    );

    // Compteur pour suivre le nombre de requêtes terminées
    let requestsCompleted = 0;
    const totalRequests = 2;

    const checkIfAllLoaded = () => {
      requestsCompleted++;
      if (requestsCompleted >= totalRequests) {
        // Petit délai pour éviter le flash
        setTimeout(() => {
          this.isLoading = false;
          this.isContentReady = true;
        }, 100);
      }
    };

    combineLatest([
      this.content.getData(),
      this.route.queryParams
    ]).subscribe(([data, param]) => {
      this.articles = (data as any).data || [];
      const tagParam = decodeURIComponent(param['tag'] || '').toLowerCase();

      if (this.validCategories.includes(tagParam)) {
        // Cas 1 : filtre par nom de catégorie
        this.data = this.articles.filter((post: any) => {
          const categoryName = post.attributes.category?.data?.attributes?.name?.toLowerCase();
          return categoryName === tagParam;
        });
      } else if (tagParam) {
        // Cas 2 : filtre par tag
        this.data = this.articles.filter((post: any) => {
          const tags_names = post.attributes.post_tags?.data?.map((tag: any) =>
            this.normalizeTag(tag.attributes.tag)
          ) || [];
          return tags_names.includes(tagParam);
        });
      } else {
        // Cas 3 : aucun filtre
        this.data = this.articles;
      }

      this.displayedArticles = this.data.slice(0, this.articlesPerPage);
      checkIfAllLoaded();
    });

    this.content.getSpotlight().subscribe((data: any) => {
      if (data.data.length > 0) {
        this.featuredArticle = data?.data[0].attributes;
      }
      checkIfAllLoaded();
    });
  }

  loadMoreArticles() {
    const nextCount = this.displayedArticles.length + this.articlesPerPage;
    this.displayedArticles = this.data.slice(0, nextCount);
  }

  normalizeTag(tag: string): string {
    if (!tag || typeof tag !== 'string') return '';
    return tag
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/\s+/g, '-');
  }

  getCategory(article: any) {
    if (article.attributes?.category?.data === null) return "";
    const foundArticle = this.displayedArticles.find(item => item.id === article.id);
    return foundArticle?.attributes.category?.data?.attributes || "";
  }
}